module.exports = __webpack_public_path__ + "img/icwithdraw.4f830a9c.png";